import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonModule, DatePipe, formatDate } from '@angular/common';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { str2Date } from 'globals/helpers/helpers';
import { Str2DatePipe } from 'src/app/services/pipes/Str2Date.pipe';

@Component({
    selector: 'change-schedule-date-dialog',
    template: `
<div class="change_schedule_dialog joi-dialog small">
  <div mat-dialog-content>
      <div class="calendar_control">
          <div class="month">{{calendar_month | date:'MMM yyyy'}}</div>
          <div style="flex:1"></div>
          <icon (click)="gotoMonth(-1)" matIcon="keyboard_arrow_left"></icon>
          <icon (click)="gotoMonth(1)" matIcon="keyboard_arrow_right"></icon>
      </div>
      <div class="week_header"><div class="name" *ngFor="let w of weeks">{{w}}</div></div>
      <div class="calendar">
          <div class="row" *ngFor="let idx of weeks_indexes;">
              <div class="cell" *ngFor="let d of weeks_set[idx]; last as last" [ngClass]="{last:last, grey:!dayInMonth(d.date)}" (click)="selectDate(d.date)">
                  <div class="calendar_date" [ngClass]="{schedule: d.schedule, extension: d.extension, today: d.today}">
                      <div class="date">{{d.date | date:'d'}}</div>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <div mat-dialog-actions>
      <button mat-button (click)="dialogRef.close()">CANCEL</button>
      <button mat-button color="primary" (click)="dialogRef.close({command: 'change', schedule_date: schedule_date})">OK</button>
  </div>
</div>
`,
    styleUrls: [`./onsite.page.scss`],
    standalone: true,
    providers: [Str2DatePipe],
    imports: [IconComponent, CommonModule, DatePipe],
})
export class ChangeScheduleDateDialogComponent {

  readonly weeks = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];
  schedule_date: Date;
  calendar_month: Date = new Date();
  calendar_days = [];
  weeks_indexes = [];
  weeks_set = {};
  extension_days = [];
  constructor(public dialogRef: MatDialogRef<ChangeScheduleDateDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
      this.schedule_date = data.date || str2Date(data.schedule_date)
      this.data.extension_days = this.data.extension_days || []
      this.extension_days = this.data.extension_days.map(d => this.schedule_date.getTime() + d * 24 * 60 * 60 * 1000)
      this.set_calendar(new Date(this.schedule_date))
  }
  selectDate(date) {
      this.schedule_date = date;
      this.extension_days = this.data.extension_days.map(d => date.getTime() + d * 24 * 60 * 60 * 1000)
      this.set_calendar(new Date(date));

  }
  set_calendar(date: Date) {
      this.calendar_month = new Date(date);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const date1 = new Date(date.setDate(1));
      let d1 = date1.getDay();
      if (d1 === 0) d1 = 7;
      const d_arr = [];
      let dd;
      for (let ii = 2; ii <= d1; ii++) {
          dd = new Date(date1);
          dd.setDate(ii - d1);
          d_arr.push({
              id: formatDate(dd, 'yyyyMMdd', 'en-au'), date: dd, schedule: this.schedule_date.getTime() === dd.getTime(),
              extension: this.extension_days.indexOf(dd.getTime()) > -1, today: dd.getTime() === today.getTime()
          });
      }
      let i = 1;
      const mm = date1.getMonth();
      do {
          dd = new Date(date1);
          dd.setDate(i++);
          d_arr.push({
              id: formatDate(dd, 'yyyyMMdd', 'en-au'), date: dd, schedule: this.schedule_date.getTime() === dd.getTime(),
              extension: this.extension_days.indexOf(dd.getTime()) > -1, today: dd.getTime() === today.getTime()
          });
      } while (dd.getMonth() === mm || dd.getDay() > 0);
      this.calendar_days = d_arr;
      this.weeks_indexes = this.weekIndexes(d_arr);
      this.weeks_set = {};
      this.weeks_indexes.forEach(idx => {
          this.weeks_set[idx] = this.weekSet(d_arr, idx);
      });
  }
  private weekIndexes(days: any[]): any[] {
      return Array.apply(null, Array(Math.floor(days.length / 7))).map((x, i) => i);
  }
  private weekSet(days: any[], week_idx) {
      return days.filter((d, i) => week_idx * 7 <= i && i < (week_idx + 1) * 7);
  }
  dayInMonth(date: Date) {
      return date.getMonth() === this.calendar_month.getMonth();
  }
  gotoMonth(num) {
      const dd = this.calendar_month;
      dd.setMonth(dd.getMonth() + num);
      this.set_calendar(dd);
  }



}

